"use client";

import { createContext, useContext, useState, ReactNode } from 'react';
import { LiveChatRoom } from '@/services/liveChatService';

interface ConnectRequest {
  roomId: string;
  user: LiveChatRoom['user'];
  requestedAt: Date;
}

interface ConnectRequestContextType {
  connectRequest: ConnectRequest | null;
  setConnectRequest: (request: ConnectRequest | null) => void;
  greetingMessage: string;
  setGreetingMessage: (message: string) => void;
}

const ConnectRequestContext = createContext<ConnectRequestContextType | undefined>(undefined);

export function ConnectRequestProvider({ children }: { children: ReactNode }) {
  const [connectRequest, setConnectRequest] = useState<ConnectRequest | null>(null);
  const [greetingMessage, setGreetingMessage] = useState('');

  return (
    <ConnectRequestContext.Provider value={{ 
      connectRequest, 
      setConnectRequest, 
      greetingMessage, 
      setGreetingMessage 
    }}>
      {children}
    </ConnectRequestContext.Provider>
  );
}

export function useConnectRequest() {
  const context = useContext(ConnectRequestContext);
  if (context === undefined) {
    throw new Error('useConnectRequest must be used within a ConnectRequestProvider');
  }
  return context;
}

